"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTwitter = function IconTwitter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M20 7.92v.53A11.59 11.59 0 0 1 8.29 20.13 11.5 11.5 0 0 1 2 18.28q.498.062 1 .06a8.25 8.25 0 0 0 5.09-1.76 4.11 4.11 0 0 1-3.83-2.85 4 4 0 0 0 1.85-.07 4.1 4.1 0 0 1-3.29-4v-.07a4.05 4.05 0 0 0 1.86.51 4.11 4.11 0 0 1-1.29-5.48 11.66 11.66 0 0 0 8.46 4.29 4.11 4.11 0 0 1 7-3.74 8.2 8.2 0 0 0 2.61-1 4.12 4.12 0 0 1-1.81 2.27A8 8 0 0 0 22 5.79a8.1 8.1 0 0 1-2 2.13"
  })));
};

export { IconTwitter, IconTwitter as default };
